import {useState} from 'react';
import {useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';
import Infobox from './InfoboxCmp';
import {handleRotate} from '../helpers/scene';
import ModalVideoCmp from "./ModalVideoCmp";
import {isMobile} from 'react-device-detect'

const HotspotDetails = ({ type, radius, text, img, link, productId, linkRotation, videoId, channel }) => {
  const history = useHistory();
  const [showInfo, setShowInfo] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [clicked, setClicked] =  useState(0)
  
  const onClose = () => {
    setShowVideo(() => false);
  }

  const onOpen = () => {
    setShowVideo(() => true);
  }

  const mobileAddToCart = (productId) => {
    const shopifyButton = document.querySelector(`#product-component-${productId} .shopify-buy__btn`);
    console.log(shopifyButton);
    if (clicked > 0) {
      shopifyButton.click();
    } else {
      setClicked(clicked+1);
      if (shopifyButton.disabled) {
        shopifyButton.disabled = false
      }
    }
  }

  const handleAddToCart = (productId) => {
    const shopifyButton = document.querySelector(`#product-component-${productId} .shopify-buy__btn`);
    console.log(shopifyButton);
    if (shopifyButton.disabled) {
      shopifyButton.disabled = false
    }
    shopifyButton.click()
  };

  const handleLink = (link, linkRotation) => {
    handleRotate(linkRotation);
    history.push(link);
  };

  const handleExternalLink = (link) => {
    window.open(link, '_blank')
  }


  switch (type) {
    case "arrow":
      return (
        <a-circle
          opacity="0.95"
          src={`#${type}`}
          radius={radius}
          onClick={() => handleLink(link, linkRotation)}
          className="clickable"
        >
        </a-circle>
      );
    case "external-arrow":
      return (
        <a-circle
          opacity="0.95"
          src={`#${type}`}
          radius={radius}
          onClick={() => handleExternalLink(link)}
          className="clickable"
        >
        </a-circle>
      )
    case "spot":
      return (
        <a-circle
          opacity="0.85"
          src={`#${type}`}
          radius={radius}
          onClick={() => handleLink(link, linkRotation)}
          className="clickable"
        >
        </a-circle>
      );
    case "gameLink":
      return (
        <a-circle
          link={`href: ${link};`}
          src={`#${type}`}
          radius={radius}
          className="clickable"
        >
        </a-circle>
      );
    case "info":
      return (
        <>
          <a-circle
            src={`#${type}`}
            radius={radius}
            onClick={() => setShowInfo(!showInfo)}
            className="clickable"
          >
          </a-circle>
          {showInfo && (
            <Infobox
              xPosition={2.25}
              yPosition={-1}
              zPosition={0}
              text={text ? text : null}
              img={img ? img : null}
            />
          )}
        </>
      );
    case "play":
      return (
        <>
          <a-circle
            opacity="0.85"
            src={`#${type}`}
            radius={radius}
            onClick={() => onOpen()}
            className="clickable"
          >
          </a-circle>
          <ModalVideoCmp
            videoId={videoId}
            channel={channel}
            onClose={onClose}
            isOpen={showVideo}
          />
        </>
      );
    case "cart":
      if (isMobile) {
        return(
          <a-circle
            src={`#${type}`}
            radius={radius}
            onClick={() => mobileAddToCart(productId)}
            className="clickable">
          </a-circle>
        )
      } else {
        return (
          <a-circle
            src={`#${type}`}
            radius={radius}
            onClick={() => handleAddToCart(productId)}
            className="clickable">
          </a-circle>
        );
      }
       
    default:
      return;
  }
};

HotspotDetails.propTypes = {
  type: PropTypes.string.isRequired,
  radius: PropTypes.number,
  text: PropTypes.string,
  img: PropTypes.string,
  link: PropTypes.string,
  productId: PropTypes.string,
  linkRotation: PropTypes.number,
  channel: PropTypes.string,
  videoId: PropTypes.string,
};

const HotspotCmp = ({ type, radius, img, text, link, productId,
  xPosition, yPosition, zPosition,
  xRotation, yRotation, zRotation, linkRotation, videoId, channel }) => {

  return (
    <a-entity
      position={`${xPosition} ${yPosition} ${zPosition}`}
      rotation={`${xRotation} ${yRotation} ${zRotation}`}
    >
      <HotspotDetails
        type={type} radius={radius}
        img={img} text={text} link={link} productId={productId}
        linkRotation={linkRotation}
        channel={channel} videoId={videoId}
      />
    </a-entity>
  );
}

HotspotCmp.propTypes = {
  type: PropTypes.string.isRequired,
  radius: PropTypes.number,
  xPosition: PropTypes.number,
  yPosition: PropTypes.number,
  zPosition: PropTypes.number,
  xRotation: PropTypes.number,
  yRotation: PropTypes.number,
  zRotation: PropTypes.number,
  text: PropTypes.string,
  img: PropTypes.string,
  link: PropTypes.string,
  productId: PropTypes.string,
  linkRotation: PropTypes.number,
  channel: PropTypes.string,
  videoId: PropTypes.string,
}

HotspotCmp.defaultProps = {
  radius: 0.25,
  xPosition: 0,
  yPosition: 0,
  zPosition: 0,
  xRotation: 0,
  yRotation: 0,
  zRotation: 0,
  linkRotation: 0,
}

export default HotspotCmp;